






































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import InputPageWrapper from '@/views/components/input/InputPageWrapper.vue';

import { UnitSystem } from '@/interfaces/units';
import { ILayerDef, OutputObj } from '@/modules/design/interfaces/shared';
import { calculateRigidDesign } from '@/modules/design/lib/calculations/newConcreteCalculation';
import { concreteMetricToImperial } from '@/modules/design/lib/unitConversion/concrete';
import QuickHelp from '@/views/components/input/QuickHelp.vue';
import GenericPavementDiagram from '@/modules/design/views/components/GenericPavementDiagram.vue';
import { designStore } from '@/store/store';
import { DEGF_TO_DEGC, PSI_TO_MPA, roundAfterUnitConversion } from '@/lib/unitConversion/unitConversionFactors';
import ValidatedInputPageWrapper from '@/views/components/input/ValidatedInputPageWrapper.vue';
import { createConcreteValidations } from '@/modules/design/lib/validations/concrete';
import {imperialPrecision, metricPrecision} from "@/main";
import ScenarioInformationReport from "@/modules/design/views/components/report/ScenarioInformationReport.vue";
import DesignParametersReport from "@/modules/design/views/components/report/DesignParametersReport.vue";
import AsphaltStructureReport from "@/modules/design/views/components/report/LayersReport.vue";
import LayersReport from "@/modules/design/views/components/report/LayersReport.vue";


@Component({
  components: {
    LayersReport,
    AsphaltStructureReport,
    DesignParametersReport,
    ScenarioInformationReport,
    ValidatedInputPageWrapper,
    GenericPavementDiagram,
    InputPageWrapper,
    QuickHelp,
  },
})
export default class NewConcreteReport extends Vue {
  scenarioType = 'New Concrete';

  @Prop() readonly page!: number;

  get scenario() {
    return designStore.currentConcrete;
  }

  get scenarioImperial() {
    return designStore.currentConcreteImperial;
  }


  get resultPrecision() {
    return this.scenario.unitSystem === UnitSystem.Imperial ? imperialPrecision : metricPrecision;
  }

  validations() {
    return createConcreteValidations(this.scenarioImperial);
  }

  save() {
    designStore.saveCurrentConcreteScenario();
  }

  get results(): OutputObj | null {
    if (this.scenario.unitSystem === UnitSystem.Metric) {
      return calculateRigidDesign(concreteMetricToImperial(this.scenario));
    }
    return calculateRigidDesign(this.scenario);
  }

  get layers(): ILayerDef[] {
    let layers: ILayerDef[] = [];

    if (this.results !== null) {
      layers = this.results.layers.map((layer) => {
        const layerDef = {
          name: layer.label,
          thickness: layer.depth,
          unit: this.thicknessUnit,
          type: layer.type === 'pcc' ? 'concrete' : 'base',
        };

        if (layerDef.name === 'Base') {
          layerDef.name = `${this.scenario.baseLayerType} base`;
        }

        return layerDef;
      });

      layers.push({
        name: 'Subgrade',
        type: 'subgrade',
        thickness: null,
        unit: this.thicknessUnit,
      });
    }

    return layers;
  }

  get unitSystemIsImperial() {
    return this.scenario.displayUnits === UnitSystem.Imperial;
  }

  get thicknessUnit(): 'in' | 'cm' {
    return this.scenario.unitSystem === UnitSystem.Imperial
      ? 'in'
      : 'cm';
  }

  get thicknessMultiplier() {
    return this.scenario.unitSystem === UnitSystem.Imperial ? 1 : 2.54;
  }

  tempDiffInProperUnits(t: number) {
    return this.scenario.unitSystem === UnitSystem.Imperial ? t : t * (5 / 9);
  }

  get tempUnits() {
    return this.scenario.unitSystem === UnitSystem.Imperial ? 'F' : 'C';
  }

  get tempMultiplierFcn() {
    return this.unitSystemIsImperial ? (degF: number) => degF : DEGF_TO_DEGC;
  }

  get pressureUnit() {
    return this.unitSystemIsImperial ? 'PSI' : 'MPa';
  }

  get pressureMultiplier() {
    return this.unitSystemIsImperial ? 1 : PSI_TO_MPA;
  }

  round(v: number) {
    return roundAfterUnitConversion(v);
  }

  mounted() {
    // console.log(this.results);
  }
}
